import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import CriarPpagModal from "./criar/CriarPpagModal.vue";
import EditarPpagModal from "./editar/EditarPpagModal.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import ActionButtons from "../../components/actions/ActionButtons.vue";
import { PpagService } from "../../services/PpagService";
import { ExercicioService } from "../../services/ExercicioService";
import { AcaoService } from "../../services/AcaoService";
import { IpgService } from "../../services/IpgService";
import { IpuService } from "../../services/IpuService";
import { GrupoService } from "../../services/GrupoService";
import { SecaoService } from "../../services/SecaoService";
import { ElementoItemService } from "../../services/ElementoItemService";
import AutocompleteField from "../../components/fields/autocompleteField/AutocompleteField.vue";
import TextField from "../../components/fields/textField/TextField.vue";

export default {
    name: "GerenciarPpags",
    components: {
        Breadcrumb,
        CriarPpagModal,
        EditarPpagModal,
        StandardPagination,
        ActionButtons,
        TextField,
        AutocompleteField
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Unidades Primárias de Crédito (PPAG)',
                disabled: false
            },
            {
                text: 'Gerenciar PPAG',
                disabled: true
            }
        ],
        // Headers atualizados conforme os critérios de aceite (13 colunas fixas)
        headers: [
            { text: 'Exercício', align: 'center', value: 'exercicio', sortable: true },
            { text: 'UO', align: 'center', value: 'codigo_ppag', sortable: true },
            { text: 'Ação', align: 'center', value: 'acao', sortable: true },
            { text: 'IPU', align: 'center', value: 'ipu', sortable: true },
            { text: 'IPG', align: 'center', value: 'ipg', sortable: true },
            { text: 'Detalhamento', align: 'center', value: 'detalhamento', sortable: true },
            { text: 'El. Item', align: 'center', value: 'elemento_item', sortable: true },
            { text: 'Gerência', align: 'center', value: 'gerencia', sortable: true },
            { text: 'Grupo', align: 'center', value: 'grupo', sortable: true },
            { text: 'Seção', align: 'center', value: 'secao', sortable: true },
            { text: 'Status', align: 'center', value: 'ativo', sortable: true }
        ],
        filters: {
            codigoPpagFilter: '',
            detalhamentoPpagFilter: '',
            exercicioFilter: null,
            acaoFilter: null,
            ipuFilter: null,
            ipgFilter: null,
            grupoFilter: null,
            secaoFilter: null,
            elementoItemFilter: null,
            statusFilter: null, // Novo filtro de status unificado
        },
        items: [],
        itemSelected: [],
        modalEdit: false,
        modalCreate: false,
        exerciciosOptions: [],
        acaoOptions: [],
        ipuOptions: [],
        ipgOptions: [],
        grupoOptions: [],
        secaoOptions: [],
        elementoItemOptions: [],
        statusOptions: [
            { text: 'Ativo', value: 'ativo' },
            { text: 'Inativo', value: 'inativo' }
        ],
        page: 1,
        totalItems: 0,
        itemsPerPage: 10,
        itemsPerPageOptions: [10, 25, 50],
        showFilters: true // Controle de visibilidade dos filtros
    }),
    computed: {
        // Computed properties para controle de seleção
        isAllSelected() {
            return this.items.length > 0 && this.itemSelected.length === this.items.length;
        },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        },
        computedHeaders() {
            return this.headers;
        }
    },
    created() {
        this.listarPpagsPaginado();
        this.listarExerciciosSelect();
        this.listarAcoesSelect();
        this.listarIpusSelect();
        this.listarIpgsSelect();
        this.listarGruposSelect();
        this.listarSecoesSelect();
        this.listarElementosItensSelect();
    },
    watch: {
        'filters.codigoPpagFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1; // Reset para primeira página ao filtrar
                this.listarPpagsPaginado();
            }
        },
        'filters.detalhamentoPpagFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarPpagsPaginado();
            }
        },
        'filters.exercicioFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarPpagsPaginado();
            }
        },
        'filters.acaoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarPpagsPaginado();
            }
        },
        'filters.ipgFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarPpagsPaginado();
            }
        },
        'filters.ipuFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarPpagsPaginado();
            }
        },
        'filters.grupoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarPpagsPaginado();
            }
        },
        'filters.secaoFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarPpagsPaginado();
            }
        },
        'filters.elementoItemFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarPpagsPaginado();
            }
        },
        'filters.statusFilter': function(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.page = 1;
                this.listarPpagsPaginado();
            }
        }
    },
    methods: {
        // Método para truncar texto
        truncateText(text, maxLength) {
            if (!text) return '-';
            if (text.length <= maxLength) return text;
            return text.substring(0, maxLength) + '...';
        },

        // Método para alternar seleção de todos os itens
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.itemSelected = [];
            } else {
                this.itemSelected = [...this.items];
            }
        },

        // Método para alternar visibilidade dos filtros
        toggleFilters() {
            this.showFilters = !this.showFilters;
        },

        // Método para classe das linhas - removido parâmetro não utilizado
        getRowClass() {
            return '';
        },

        // Métodos para controle da paginação
        handlePageChange(newPage) {
            this.page = newPage;
            this.listarPpagsPaginado();
        },

        handleItemsPerPageChange(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.page = 1; // Reset para primeira página ao mudar itens por página
            this.listarPpagsPaginado();
        },

        // Métodos renomeados para seguir padrão
        handlePageChanged(newPage) {
            this.handlePageChange(newPage);
        },

        handleItemsPerPageChanged(newItemsPerPage) {
            this.handleItemsPerPageChange(newItemsPerPage);
        },

        // Métodos para os botões de ação padronizados
        handleInsert() {
            // Navegar para página de criação
            this.$router.push('/ppags/criar');
        },

        handleEdit() {
            // Navegar para página de edição com o item selecionado
            if (this.itemSelected.length === 1) {
                this.$router.push(`/ppag/editar/${this.itemSelected[0].id}`);
            }
        },

        handleExport() {
            // Implementar lógica de exportação
            this.$router.push('/importar-elementos-primarios');
        },

        // Métodos para navegação
        navigateToCreate() {
            this.handleInsert();
        },

        navigateToEdit() {
            this.handleEdit();
        },

        // Métodos existentes mantidos
        async listarPpagsPaginado() {
            try {
                const filter = this.prepareFormFilter();

                const response = await PpagService.index(filter);

                if (typeof response !== 'string') {
                    this.items = response.data.data;
                    this.totalItems = response.data.total;
                    this.itemSelected = [];
                    this.$forceUpdate();
                } else {
                    console.error('Não foi possível obter os ppags.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os ppags:', error);
            }
        },

        async listarExerciciosSelect() {
            try {
                const response = await ExercicioService.select();
                if (response) {
                    this.exerciciosOptions = response.data.map((el) => {
                        return {
                            text: el.ano,
                            value: el.ano,
                        };
                    });
                } else {
                    console.error('Não foi possível obter os exercícios.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os exercícios:', error);
            }
        },

        async listarAcoesSelect() {
            try {
                const response = await AcaoService.select();

                if (response) {
                    this.acaoOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_acao} - ${el.descricao_acao}`,
                            value: el.id,
                        };
                    });
                } else {
                    console.error('Não foi possível obter as ações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar as ações:', error);
            }
        },

        async listarIpusSelect() {
            try {
                const response = await IpuService.select();
                if (response) {
                    this.ipuOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_ipu} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                } else {
                    console.error('Não foi possível obter os IPUs.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os IPUs:', error);
            }
        },

        async listarIpgsSelect() {
            try {
                const response = await IpgService.select();
                if (response) {
                    this.ipgOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_ipg} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                } else {
                    console.error('Não foi possível obter os IPGs.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os IPGs:', error);
            }
        },

        async listarGruposSelect() {
            try {
                const response = await GrupoService.select();
                if (response) {
                    this.grupoOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_grupo} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                } else {
                    console.error('Não foi possível obter os grupos.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os grupos:', error);
            }
        },

        async listarSecoesSelect() {
            try {
                const response = await SecaoService.select();
                if (response) {
                    this.secaoOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_secao}`,
                            value: el.id,
                        };
                    });
                } else {
                    console.error('Não foi possível obter as seções.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar as seções:', error);
            }
        },

        async listarElementosItensSelect() {
            try {
                const response = await ElementoItemService.select();
                if (response) {
                    this.elementoItemOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_elemento_item} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                } else {
                    console.error('Não foi possível obter os elementos/itens.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os elementos/itens:', error);
            }
        },

        async destroyPpags() {
            try {
                const ids = this.itemSelected.map(ppag => ppag.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("ppags[]", id);
                });

                const response = await PpagService.destroy(formData);

                if (!response) {
                    console.error('Não foi possível excluir os ppags.');
                }

                this.listarPpagsPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao excluir os ppags:', error);
            }
        },

        async activatePpags() {
            try {
                const ids = this.itemSelected.map(ppag => ppag.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("ppags[]", id);
                });

                const response = await PpagService.activate(formData);

                if (!response) {
                    console.error('Não foi possível ativar os ppags.');
                }

                this.listarPpagsPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao ativar os ppags:', error);
            }
        },

        async deactivatePpags() {
            try {
                const ids = this.itemSelected.map(ppag => ppag.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("ppags[]", id);
                });

                const response = await PpagService.deactivate(formData);

                if (!response) {
                    console.error('Não foi possível desativar os ppags.');
                }

                this.listarPpagsPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao desativar os ppags:', error);
            }
        },

        openModal(value) {
            if (value == 'create') {
                this.modalCreate = true;
            }
            if (value == 'edit') {
                this.modalEdit = true;
            }
        },

        closeActionsDialog() {
            this.modalCreate = false;
        },

        prepareFormFilter() {
            const filter = new FormData();

            filter.append("page", this.page);
            filter.append("per_page", this.itemsPerPage);

            this.filters.codigoPpagFilter
            ? filter.append(
                "codigo",
                this.filters.codigoPpagFilter
            )
            : null;

            this.filters.detalhamentoPpagFilter
                ? filter.append(
                    "detalhamento",
                    this.filters.detalhamentoPpagFilter
                )
                : null;

            this.filters.acaoFilter
                ? filter.append(
                    "acao_id",
                    this.filters.acaoFilter
                )
                : null;    

            this.filters.ipgFilter
                ? filter.append(
                    "ipg_id",
                    this.filters.ipgFilter
                )
                : null; 
                
            this.filters.ipuFilter
                ? filter.append(
                    "ipu_id",
                    this.filters.ipuFilter
                )
                : null;  

            this.filters.grupoFilter
                ? filter.append(
                    "grupo_id",
                    this.filters.grupoFilter
                )
                : null;  
                
            this.filters.secaoFilter
                ? filter.append(
                    "secao_id",
                    this.filters.secaoFilter
                )
                : null;    

            this.filters.elementoItemFilter
                ? filter.append(
                    "elemento_item_id",
                    this.filters.elementoItemFilter
                )
                : null;     

            this.filters.exercicioFilter
                ? filter.append(
                    "exercicio",
                    this.filters.exercicioFilter
                )
                : null;

            // Filtro de status unificado
            if (this.filters.statusFilter) {
                if (this.filters.statusFilter === 'ativo') {
                    filter.append("ativo", true);
                } else if (this.filters.statusFilter === 'inativo') {
                    filter.append("inativo", true);
                }
            }

            return filter;
        },
    }
};
